export const projectsDatas = [
  {
    id: 1,
    title: 'Göker Blog',
    usedTechnology: 'React, Css, HTML',
    summery:
      'My first project where I shared the steps I took while becoming a developer.',
    projectlink: '/',
  },
];
